// extracted by mini-css-extract-plugin
module.exports = {"button":"carousel_controller-module__button--2i8nP","right":"carousel_controller-module__right--3ufJX","left":"carousel_controller-module__left--2_dXR"};